import { render, staticRenderFns } from "./FacilitiesTable.vue?vue&type=template&id=06ab1dc2"
import script from "./FacilitiesTable.vue?vue&type=script&lang=js"
export * from "./FacilitiesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports